import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroAsesoria from './components/HeroAsesoria';
import ProblemsSection from './components/ProblemsSection';
import MethodSection from './components/MethodSection';
import DigitalSystemSection from './components/DigitalSystemSection';
import BenefitsSection from './components/BenefitsSection';
import StepsSection from './components/StepsSection';
import DifferentiationSection from './components/DifferentiationSection';
import PlansSection from './components/PlansSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Asesoría de Imagen Personal Anthony Sánchez',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  description:
    'Sistema integral de asesoría de imagen personal con método propio, organización de armario, diseño de looks estratégicos y plataforma digital inteligente.',
  serviceType: 'Asesoría de Imagen Personal',
  priceRange: '€€€€',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Asesoría de Imagen',
      item: 'https://anthonysanchezc.com/asesoria-imagen',
    },
  ],
};

export default function AsesoriaImagen() {
  useSEO({
    title:
      'Asesoría de Imagen Barcelona | Personal Shopper | Anthony Sánchez Couture',
    description:
      'Sistema integral de asesoría de imagen personal en Barcelona. Organización de armario inteligente, looks estratégicos, diseño a medida y plataforma digital. Método propio de Anthony Sánchez.',
    keywords:
      'asesoría de imagen, personal shopper, alta costura, estilo personal, armario inteligente, organización armario, asesoría imagen Barcelona, estilo hombre, estilo mujer, looks estratégicos',
    canonical: '/asesoria-imagen',
    ogTitle: 'Asesoría de Imagen Barcelona — Estrategia Personal',
    ogDescription:
      'Anthony Sánchez diseña, organiza y optimiza tu imagen completa. Un sistema integral donde tu estilo se alinea con tu vida, tus objetivos y tu perfil psicológico.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={serviceSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <HeroAsesoria />
        <ProblemsSection />
        <MethodSection />
        <DigitalSystemSection />
        <BenefitsSection />
        <StepsSection />
        <DifferentiationSection />
        <PlansSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}